<template>
  <div class="d-flex p-2 mini">
    <audio ref="video"
      :src="video.url"
      v-show="false" />

    <div class="p-2" style="width: 50px;">
      <button class="btn active" @click="play()" v-if="video.state !== 'playing'">
        <img src="../../assets/images/btn_text_play.png" height="35" />
      </button>

      <button class="btn active" @click="pause()" v-else>
        <img src="../../assets/images/btn_text_pause.png" height="35" />
      </button>
    </div>

    <div class="p-2 w-100">
      <progress-bar :position="video.currentPos" v-on:seekTo="seekTo"></progress-bar>
      <div class="d-flex justify-content-start pt-2 pb-2">
        <div>
          <button
            v-bind:class="{ 'btn': true, 'active': reset }"
            @click="seekToResetAction()">
            <img src="../../assets/images/btn_text_back_to_start_on.png" v-show="reset" />
            <img src="../../assets/images/btn_text_back_to_start_off.png" v-show="!reset" />
          </button>

          <button
            v-bind:class="{ 'btn': true, 'active': repeat && repeatIdx > -1 }"
            @click="repeatSingle()">
            <img src="../../assets/images/btn_text_replay_on.png" v-if="repeat && repeatIdx > -1" />
            <img src="../../assets/images/btn_text_replay_off.png" v-if="!repeat || repeatIdx === -1" />
          </button>

          <button
            v-bind:class="{ 'btn': true, 'active': video.slow }"
            @click="slower()"
            v-if="slowAudioUrl">
            <img src="../../assets/images/btn_text_slow_on.png" v-if="video.slow" />
            <img src="../../assets/images/btn_text_slow_off.png" v-if="!video.slow" />
          </button>

          <button
            v-bind:class="{ 'btn': true, 'active': repeat && repeatIdx === -1 }"
            @click="repeatAll()">
            <img src="../../assets/images/btn_text_loop_on.png" v-if="repeat && repeatIdx === -1" />
            <img src="../../assets/images/btn_text_loop_off.png" v-if="!repeat || repeatIdx > -1" />
          </button>

          <a class="btn active" download :href="video.url" v-if="video.url.indexOf('blob:') > -1">
            <i class="fas fa-cloud-download-alt" aria-label="download"></i>
          </a>
        </div>

        <div class="ml-auto">
          <span class="btn active">{{ duration(video.currentTime) }} | {{ duration(video.duration) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import fontawesome from '../../../node_modules/@fortawesome/fontawesome'
  // import { faCloudDownloadAlt } from '../../../node_modules/@fortawesome/fontawesome-free-solid'
  import progressBar from './ProgressBar.vue'
  import playerMixin from '../mixins/playerMixin.js'

  // fontawesome.library.add(faCloudDownloadAlt)

  export default {

    name: 'MiniPlayer',

    props: {
      slowAudioUrl: {
        type: String,
        required: false,
        default: ''
      }
    },

    components: {
      progressBar
    },

    mixins: [playerMixin],

    data () {
      return {
        reset: false
      }
    },

    methods: {
      slower () {
        var state = this.video.state
        this.pause()
        this.video.slow = !this.video.slow
        this.video.url = this.video.slow ? this.slowAudioUrl : this.url

        this.$nextTick(() => {
          this.video.pos = this.video.currentPos
          if (state === 'playing') {
            this.play()
          }
        })
      },

      seekToResetAction () {
        this.seekTo(0)
        this.reset = true
        var self = this
        window.setTimeout(() => {
          self.reset = false
        }, 500)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/app.scss";

  .mini {
    background-color: #fff;
    border: 1px #ccc solid;
    border-bottom: 0 !important;
  }

  button,
  .btn {
    color: $light;
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
    padding: 5px;

    img {
      padding: 0 3px;
      margin-top: -3px;
    }

    &.active {
      color: black;
    }

    &:focus {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// MiniPlayer.vue?dde9f8c4